import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FeedService {
    baseUrl: string;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = baseUrl + 'api/feeds';
    }

    getFeeds(schoolFeed: string): Observable<any[]> {
        const params = new HttpParams()
            .set('id', '8CE8F50F-8824-4D39-9683-A9CB736949E5')
            .set('schoolFeedUrl', schoolFeed)
            // .set('callback', '');
        // return this.http.get<any[]>(`http://localhost:20003/GenericService.svc/json/GetDistrictSchoolCombinedRSSfeed`, {params});
        // return this.http.get<any[]>(`https://webservicesdev.polk-fl.net/c/GenericService.svc/json/GetDistrictSchoolCombinedRSSfeed`, {params});
        return this.http.get<any[]>(`${this.baseUrl}/schoolrss`, { params });
    }

    // https://webservicesdev.polk-fl.net/c/GenericService.svc/json/GetDistrictSchoolCombinedRSSfeed?id=8CE8F50F-8824-4D39-9683-A9CB736949E5&schoolFeedUrl=https://slhe.polkschoolsfl.com/feed&callback=
}
